import React from 'react';

class Features extends React.Component {
    render() {
        return (
            <div id="feature">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <div className="text-wrapper">
                                <div>
                                    <h1 className="title-hl wow fadeInLeft" data-wow-delay="0.3s">We design & build beautiful <br /> software products</h1>
                                    <p className="mb-4">We build code, custom software products, back-end solutions & websites. Technology is our tool, but the goal is to create a business that can thrive. Our code team sets the development focus. Weaving in business adaptability with technology-savvy websites, mobile and web applications using cutting-edge technology. What makes us a step closer to our vision is our adaptability and integrity.</p>
                                    <a href="#contact" className="btn btn-common">Contact Us</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12 padding-none feature-bg">
                            <div className="feature-thumb">
                                <div className="feature-item wow fadeInDown" data-wow-duration="1000ms" data-wow-delay="300ms">
                                    <div className="icon">
                                        <i className="lni-bulb"></i>
                                    </div>
                                    <div className="feature-content">
                                        <h3>What we do</h3>
                                        <p>We help you achieve & accelerate growth and empower clients to grow their businesses based on the effective use of technology.</p>
                                    </div>
                                </div>
                                <div className="feature-item wow fadeInDown" data-wow-duration="1000ms" data-wow-delay="500ms">
                                    <div className="icon">
                                        <i className="lni-target"></i>
                                    </div>
                                    <div className="feature-content">
                                        <h3>Our approach</h3>
                                        <p>We know that great solutions don’t happen by accident. Our process starts with asking “Why?” and evolves through rapid cycles of innovation. </p>
                                    </div>
                                </div>
                                <div className="feature-item wow fadeInDown" data-wow-duration="1000ms" data-wow-delay="700ms">
                                    <div className="icon">
                                        <i className="lni-medall-alt"></i>
                                    </div>
                                    <div className="feature-content">
                                        <h3>Our mission</h3>
                                        <p>If you can dream it, we can build it and, we work to make our customers happy through the dedication and professionalism of our team.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Features;


// WEBPACK FOOTER //
// ./src/sections/Features.js